<template>
  <div class="footer">
    <div class="container text-right">
      {{ $t('src/views/footerbody.7691', { '1': version, '2': buildDate }) }}
    </div>
  </div>
</template>

<script>
import { DATE_FORMAT } from '@/main.config'

const versionConfig = require('@/version.config.json')

export default {
  name: 'FooterBody',
  computed: {
    version() {
      return versionConfig.version
    },
    buildDate() {
      return this.moment(versionConfig.timestamp).format(DATE_FORMAT.ru)
    }
  }
}
</script>
